module.exports = __webpack_public_path__ + "img/photosession_1_13.42a9557d.jpg";